module.exports = __webpack_public_path__ + "static/img/viral_07.4d26cbbf.jpg";